/*
  LCC 4a — Garage de vehículo
  Guarda el vehículo elegido por el visitante (marca / línea / generación)
  en localStorage y adapta cualquier elemento marcado con
  [data-lcc-garage-label] o [data-lcc-garage-empty] sin recargar la página.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'lcc_garage_vehicle';
  var EVENT_NAME = 'lcc:vehicle-changed';

  function safeStorage() {
    try {
      var testKey = '__lcc_test__';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  var storage = safeStorage();
  var memoryFallback = null;

  function get() {
    if (!storage) return memoryFallback;
    try {
      var raw = storage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function set(vehicle) {
    if (storage) {
      try {
        storage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
      } catch (e) { /* cuota llena o modo privado */ }
    }
    memoryFallback = vehicle;
    render(vehicle);
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: vehicle }));
  }

  function clear() {
    if (storage) {
      try { storage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
    }
    memoryFallback = null;
    render(null);
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));
  }

  function render(vehicle) {
    var labels = document.querySelectorAll('[data-lcc-garage-label]');
    var emptyEls = document.querySelectorAll('[data-lcc-garage-empty]');
    var filledEls = document.querySelectorAll('[data-lcc-garage-filled]');
    var links = document.querySelectorAll('[data-lcc-garage-link]');

    labels.forEach(function (el) {
      el.textContent = vehicle ? vehicle.label : el.getAttribute('data-lcc-garage-label');
    });
    emptyEls.forEach(function (el) { el.hidden = !!vehicle; });
    filledEls.forEach(function (el) { el.hidden = !vehicle; });
    links.forEach(function (el) {
      if (vehicle && vehicle.collectionUrl) {
        el.setAttribute('href', vehicle.collectionUrl);
      }
    });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-lcc-garage-set]');
    if (trigger) {
      try {
        var vehicle = JSON.parse(trigger.getAttribute('data-lcc-garage-set'));
        set(vehicle);
      } catch (e) { /* payload inválido */ }
      return;
    }
    if (evt.target.closest('[data-lcc-garage-clear]')) {
      clear();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    render(get());
  });

  window.LCCGarage = { get: get, set: set, clear: clear };
})();
